import React from 'react';
import styled from 'styled-components';
import Img from 'gatsby-image';
import Link from 'gatsby-link';

class WorkPreviewCard extends React.Component {
	render() {
		const { title, featured_media, acf, slug } = this.props.portfolio.node;
		console.log(acf, 'acf');
		return (
			<div>
				<a
					target={acf.site_url !== '' ? '_blank' : ''}
					href={acf.site_url !== '' ? acf.site_url : ''}
				>
					<div className="lightbox-wrap">
						<div className="lightbox">
							<div className="lightbox-header">
								<Img
									sizes={featured_media.localFile.childImageSharp.sizes}
									style={{
										maxHeight: '300px',
										height: '300px',
										overflow: 'hidden'
									}}
									imgStyle={{
										maxHeight: '300px',
										height: '300px',
										overflow: 'hidden'
									}}
								/>
							</div>
							<div className="lightbox-body">
								<div className="title">
									<h3>{title}</h3>
								</div>
								<div className="links">
									<ul>
										{(acf.site_url !== '' || null) && (
											<li>
												<a>Visit</a>
											</li>
										)}

										{acf.case_study &&
											acf.case_study !== 'none' && (
												<li>
													<Link to={slug}>View Case Study</Link>
												</li>
											)}
									</ul>
								</div>
							</div>
						</div>
					</div>
				</a>
			</div>
		);
	}
}

export default WorkPreviewCard;



// WEBPACK FOOTER //
// ./src/components/Cards.js